import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Apakah ada persyaratan khusus untuk Android 15 ke atas?',
      answer:
        'Ya, untuk pengguna Android 15 ke atas, Anda harus menginstall BAINSTALLER dan Shizuku terlebih dahulu sebelum menginstall BAiBOT. Kedua aplikasi ini diperlukan karena perubahan sistem keamanan di Android 15. Anda bisa mendownload BAINSTALLER dan Shizuku di bagian atas halaman ini, dan tonton tutorial lengkapnya di YouTube.',
    },
    {
      question: 'Apakah BAiBOT aman digunakan?',
      answer:
        'Ya, BAiBOT menggunakan Android Accessibility Service yang merupakan fitur resmi Android. Kami tidak menyimpan data pribadi Anda dan aplikasi dilindungi dengan sistem Device ID untuk keamanan ekstra.',
    },
    {
      question: 'Apakah memerlukan izin Accessibility?',
      answer:
        'Ya, BAiBOT memerlukan izin Accessibility Service untuk dapat membaca dan berinteraksi dengan aplikasi inDriver secara otomatis. Tanpa izin ini, fitur otomasi tidak dapat berfungsi.',
    },
    {
      question: 'Bisakah saya mengkustomisasi semua filter?',
      answer:
        'Tentu! BAiBOT memberikan kontrol penuh atas filter harga, area, jarak, rating penumpang, waktu penjemputan, dan pengaturan Auto Up Price. Anda dapat mengatur semuanya sesuai preferensi.',
    },
    {
      question: 'Apakah perangkat saya aman?',
      answer:
        'Ya, BAiBOT dilengkapi dengan sistem Anti-Hack dan Device ID Protection. Setiap akses dibatasi per perangkat untuk mencegah penyalahgunaan dan menjaga keamanan akun Anda.',
    },
    {
      question: 'Bagaimana cara mendapatkan support?',
      answer:
        'Anda dapat menghubungi tim support kami melalui WhatsApp di 085175369335 atau bergabung dengan komunitas Telegram kami untuk mendapatkan bantuan dan tips dari pengguna lain.',
    },
    {
      question: 'Apakah BAiBOT afiliasi dengan inDriver?',
      answer:
        'Tidak. BAiBOT inDriver adalah aplikasi otomasi pihak ketiga yang independen dan tidak berafiliasi dengan inDriver secara resmi.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="faq"
      style={{
        background: 'var(--bg-primary)',
        padding: '100px 7.6923%',
      }}
    >
      <div
        style={{
          maxWidth: '900px',
          margin: '0 auto',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2
            style={{
              fontSize: '48px',
              fontWeight: 600,
              lineHeight: 1.1,
              letterSpacing: '-0.02em',
              color: 'var(--text-primary)',
              marginBottom: '16px',
            }}
          >
            Pertanyaan yang Sering Diajukan
          </h2>
          <p
            style={{
              fontSize: '20px',
              fontWeight: 500,
              lineHeight: 1.5,
              color: 'var(--text-secondary)',
            }}
          >
            Temukan jawaban atas pertanyaan umum tentang BAiBOT
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {faqs.map((faq, index) => (
            <div
              key={index}
              style={{
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border-subtle)',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
              }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                style={{
                  width: '100%',
                  padding: '24px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left',
                }}
              >
                <h3
                  style={{
                    fontSize: '20px',
                    fontWeight: 600,
                    color: 'var(--text-primary)',
                    margin: 0,
                  }}
                >
                  {faq.question}
                </h3>
                <ChevronDown
                  size={24}
                  color="var(--brand-primary)"
                  style={{
                    transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                  }}
                />
              </button>
              <div
                style={{
                  maxHeight: openIndex === index ? '500px' : '0',
                  overflow: 'hidden',
                  transition: 'max-height 0.3s ease',
                }}
              >
                <p
                  style={{
                    padding: '0 24px 24px',
                    fontSize: '16px',
                    lineHeight: 1.6,
                    color: 'var(--text-secondary)',
                    margin: 0,
                  }}
                >
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};